import { useFullEventChart } from './useFullEventChart';
import type { FullEventChartProps } from './eventDetailsTab.types';

/**
 * Renders the container the full-event ECG chart is drawn into. Chart creation and updates are delegated to useFullEventChart with the event data and update callback, leaving only a fixed 945 pixel wide centred div.
 *
 * @param viewFullEventData - Full event data the chart is drawn from.
 * @param updateChartData - Callback the chart hook uses to push updated chart data back.
 * @returns The chart container element.
 */
const FullEventChart = ({ viewFullEventData, updateChartData }: FullEventChartProps) => {
  useFullEventChart({ viewFullEventData, updateChartData });

  return (
    <div
      id="container"
      style={{
        width: 945,
        margin: '0 auto',
      }}
    />
  );
};

export default FullEventChart;
